export default function({ store, redirect }) {
  // If the user is authenticated redirect to products
  if (store.$auth.$state.loggedIn) {
    return redirect('/products')
  }
}
